import "./App.css";
import { useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import HomePage from "./pages/HomePage";
import ImpressumPage from "./pages/ImpressumPage";
import DatenschutzPage from "./pages/DatenschutzPage";
import MaintenancePage from "./pages/MaintenancePage";

const SHOW_MAINTENANCE_PAGE = true;

function App() {
  const [previewUnlocked, setPreviewUnlocked] = useState(false);

  return (
    <div className="App site-shell">
      <div className="bg-orb bg-orb-1" />
      <div className="bg-orb bg-orb-2" />

      {!SHOW_MAINTENANCE_PAGE || previewUnlocked ? (
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/impressum" element={<ImpressumPage />} />
          <Route path="/datenschutz" element={<DatenschutzPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      ) : (
        <MaintenancePage onUnlockPreview={() => setPreviewUnlocked(true)} />
      )}
    </div>
  );
}

export default App;
